import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { ControlContainer, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ResponseCommon, Sgkb986aRequest, Sgkb986aResponse, Sgkb986aResCtrSearchresultDto } from 'sg-api';
import { UsedSgkb986aService } from '../../../../../sg-kb-shared/services/used-sgkb986a.service';
import { MatDialogRef } from '@angular/material/dialog';
import { SgkbConstains } from '../../../../../sg-kb-shared/sg-kb-constans';

@Component({
  selector: 'app-sgkb713d-search-condition',
  templateUrl: './sgkb713d-search-condition.component.html',
  styleUrl: './sgkb713d-search-condition.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  providers: [],
})
export class Sgkb713dSearchConditionComponent implements OnInit, OnDestroy {
  /** 遷移元ステータス */
  @Input() mode: string;

  /** ボタン押下イベント */
  @Output() onClickButtonEvent =
    new EventEmitter<{
      showResult: boolean; clearExeFlg: boolean;
      ctrSearchresultList: Array<Sgkb986aResCtrSearchresultDto>
    }>();

  /** 親コンポーネント保持領域 */
  parentForm: UntypedFormGroup | null = null;;
  /** 検索情報格納FormGroup*/
  receiptSearchConditionForm: UntypedFormGroup;

  private onDestroy$ = new Subject();

  /** 契約番号 */
  keiyakuNo: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** お客さま番号 */
  okyakusamaNo: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 供給地点特定番号 */
  kyoukyuchitenTokuteiNo: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });

  /** 契約検索・一覧照会 */
  sgkb986aResponse: Sgkb986aResponse;
  /** responseCommon(SGKB986A) */
  sgkb986aResponseCommon: ResponseCommon;
  /** 契約検索結果リスト */
  ctrSearchresultList: Array<Sgkb986aResCtrSearchresultDto>;

  /**
   * コンストラクタ
   * @memberof Sgkb713dSearchConditionComponent
   */
  constructor(
    private fb: UntypedFormBuilder,
    private parent: FormGroupDirective,
    private usedSgkb986aService: UsedSgkb986aService,
    public _dialogRef: MatDialogRef<Sgkb713dSearchConditionComponent>,
  ) { }

  /**
   * 購読を停止する処理
   * @memberof Sgkb713dSearchConditionComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    this.parentForm.removeControl('receiptSearchConditionForm');
  }

  /**
   * 初期表示処理
   * @memberof Sgkb713dSearchConditionComponent
   */
  ngOnInit(): void {
    this.receiptSearchConditionForm = this.fb.group({
      keiyakuNo: this.keiyakuNo,
      okyakusamaNo: this.okyakusamaNo,
      kyoukyuchitenTokuteiNo: this.kyoukyuchitenTokuteiNo,
    });
    //親と子の紐づけを行う
    this.parentForm = this.parent.form;
    this.parentForm.addControl('receiptSearchConditionForm', this.receiptSearchConditionForm);

    // 受信データの購読設定（契約情報）
    this.usedSgkb986aService.contractorValueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.sgkb986aResponse = response;
        this.sgkb986aResponseCommon = response.responseCommon;
        this.ctrSearchresultList = response.ctrSearchresultList;
      });
  }

  /**
   * 検索押下処理
   * @memberof Sgkb713dSearchConditionComponent
   */
  onClickSearch(): void {
    // 契約検索・一覧照会レスポンスを取得
    this.usedSgkb986aService.searchContractor(this.setSgkb986aRequest())
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.sgkb986aResponse = response;
        this.sgkb986aResponseCommon = response.responseCommon;
        this.ctrSearchresultList = response.ctrSearchresultList;

        // 検索結果がある場合のみ処理を実行
        if (this.ctrSearchresultList != null) {
          // showResult：検索押下フラグ、clearExeFlg：クリア押下フラグ
          this.onClickButtonEvent.emit({
            showResult: true,
            clearExeFlg: false,
            ctrSearchresultList: this.ctrSearchresultList
          });
        }
      });
  }

  /**
   * クリア押下処理
   * @memberof Sgkb713dSearchConditionComponent
   */
  onClickClear(): void {
    // 自フォームグループをクリア
    this.receiptSearchConditionForm.reset();
    // showResult：検索押下フラグ、clearExeFlg：クリア押下フラグ
    this.onClickButtonEvent.emit({
      showResult: false,
      clearExeFlg: true,
      ctrSearchresultList: null
    });
  }

  /**
   * 閉じる押下処理
   * @memberof Sgkb713dSearchConditionComponent
   */
  onClickClose(): void {
    this._dialogRef.close();
  }

  /**
   * 契約検索・一覧照会のリクエスト設定
   * @memberof Sgkb713dSearchConditionComponent
   */
  setSgkb986aRequest(): Sgkb986aRequest {

    // ガス「01」、電気「11」
    const srvClsfyCode: string[] = [SgkbConstains.CODE.SERVICE_CLY_CD.GAS, SgkbConstains.CODE.SERVICE_CLY_CD.ELE];
    // 契約検索・一覧照会リクエストを作成
    const sgkb986aRequest: Sgkb986aRequest = {
      ctrSearchInfo: {
        firstSrvctrNo: this.keiyakuNo.value,
        srvClsfyCodeList: srvClsfyCode,
        extCnnctNo: this.kyoukyuchitenTokuteiNo.value,
        ctrStatus: SgkbConstains.CODE.CNTRCT_STATUS.ACTIVEONLY,  // 契約状況：'1'(現在契約中のみ)
        extLinkId: this.okyakusamaNo.value,
        contractlistSortPatterncode: SgkbConstains.CODE.CNTRCT_LIST_SORT_PTRN_CD.HOUKATSU_CNTRCT,  //契約一覧ソートパターンコード:'1'(包括契約)
      }
    }
    return sgkb986aRequest;
  }
}
